import GigPiece_Entity from "./gigPiece";
export default class GigPiece extends GigPiece_Entity {
  static fromList(gigPiecesJSON: unknown): Array<GigPiece> {
    const gigPieces: GigPiece[] = [];
    if (gigPiecesJSON)
      Array.isArray(gigPiecesJSON) &&
        gigPiecesJSON.forEach((gigPieceJSON) => {
          gigPieces.push(new GigPiece(gigPieceJSON));
        });
    return gigPieces;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
